import { render, staticRenderFns } from "./journalSection.vue?vue&type=template&id=3e9cd690&scoped=true&lang=html"
import script from "./journalSection.vue?vue&type=script&lang=js"
export * from "./journalSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e9cd690",
  null
  
)

export default component.exports